/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RequirementForWork,
  RequirementForWorkRequest,
  RequirementForWorksListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getRequirementForWorksListUrl = (params?: RequirementForWorksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/requirement-for-works/?${stringifiedParams}` : `/api/requirement-for-works/`
}

/**
 * Requirements that pros must satisfy before being eligible to work gigs
 * at a location.
 *
 * Examples: skill certifications, food handler cards, alcohol server permits.
 * Managers can list requirements; pros can submit proof of completion.
 */
export const requirementForWorksList = async (params?: RequirementForWorksListParams, options?: Parameters<typeof customFetch>[1]): Promise<RequirementForWork[]> => {

  return customFetch<RequirementForWork[]>(getRequirementForWorksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRequirementForWorksListQueryKey = (params?: RequirementForWorksListParams,) => {
    return [
    `/api/requirement-for-works/`, ...(params ? [params] : [])
    ] as const;
    }


export const getRequirementForWorksListQueryOptions = <TData = Awaited<ReturnType<typeof requirementForWorksList>>, TError = void>(params?: RequirementForWorksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requirementForWorksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequirementForWorksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requirementForWorksList>>> = ({ signal }) => requirementForWorksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requirementForWorksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequirementForWorksListQueryResult = NonNullable<Awaited<ReturnType<typeof requirementForWorksList>>>
export type RequirementForWorksListQueryError = void


export function useRequirementForWorksList<TData = Awaited<ReturnType<typeof requirementForWorksList>>, TError = void>(
 params: undefined |  RequirementForWorksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requirementForWorksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requirementForWorksList>>,
          TError,
          Awaited<ReturnType<typeof requirementForWorksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequirementForWorksList<TData = Awaited<ReturnType<typeof requirementForWorksList>>, TError = void>(
 params?: RequirementForWorksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requirementForWorksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requirementForWorksList>>,
          TError,
          Awaited<ReturnType<typeof requirementForWorksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequirementForWorksList<TData = Awaited<ReturnType<typeof requirementForWorksList>>, TError = void>(
 params?: RequirementForWorksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requirementForWorksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRequirementForWorksList<TData = Awaited<ReturnType<typeof requirementForWorksList>>, TError = void>(
 params?: RequirementForWorksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requirementForWorksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequirementForWorksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRequirementForWorksCreateUrl = () => {




  return `/api/requirement-for-works/`
}

/**
 * Requirements that pros must satisfy before being eligible to work gigs
 * at a location.
 *
 * Examples: skill certifications, food handler cards, alcohol server permits.
 * Managers can list requirements; pros can submit proof of completion.
 */
export const requirementForWorksCreate = async (requirementForWorkRequest: RequirementForWorkRequest, options?: Parameters<typeof customFetch>[1]): Promise<RequirementForWork> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RequirementForWork>(getRequirementForWorksCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requirementForWorkRequest)
  }
);}





export const getRequirementForWorksCreateMutationKey = () => ['requirementForWorksCreate'] as const;

export const getRequirementForWorksCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requirementForWorksCreate>>, TError,RequirementForWorksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requirementForWorksCreate>>, TError,RequirementForWorksCreateMutationVariables, TContext> => {

const mutationKey = getRequirementForWorksCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requirementForWorksCreate>>, RequirementForWorksCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requirementForWorksCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequirementForWorksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof requirementForWorksCreate>>>
    export type RequirementForWorksCreateMutationBody = RequirementForWorkRequest
    export type RequirementForWorksCreateMutationError = void
    export type RequirementForWorksCreateMutationVariables = {data: RequirementForWorkRequest}

    export const useRequirementForWorksCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requirementForWorksCreate>>, TError,RequirementForWorksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requirementForWorksCreate>>,
        TError,
        RequirementForWorksCreateMutationVariables,
        TContext
      > => {
      return useMutation(getRequirementForWorksCreateMutationOptions(options), queryClient);
    }
